import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import { ProductContext } from '../context';
import css from './index.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FabricDetails = function FabricDetails(_ref) {
  var panelTitle = _ref.title;

  var _useContext = useContext(ProductContext),
      fabric = _useContext.fabric;

  if (!fabric) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var id = fabric.id,
      description = fabric.description,
      icon = fabric.icon,
      parent = fabric.parent,
      title = fabric.title,
      url = fabric.url;
  var fabricTitle = url ? /*#__PURE__*/_jsx("a", {
    "aria-label": "This product is made with the ".concat(title, " fabric.\n      Navigate to the ").concat(title, " collection of products."),
    href: "".concat(url, "?fabric=").concat(parent ? parent.id : id),
    children: title
  }) : title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.panelTitle,
      children: [panelTitle, ":"]
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.fabricTitle,
        children: [(icon === null || icon === void 0 ? void 0 : icon.svg) && /*#__PURE__*/_jsx("div", {
          "aria-hidden": "true",
          className: css.fabricIcon,
          dangerouslySetInnerHTML: {
            __html: icon.svg
          },
          role: "presentation"
        }), /*#__PURE__*/_jsx("div", {
          children: fabricTitle
        })]
      }), description && /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: parseMarkdown(description)
        }
      })]
    })]
  });
};

FabricDetails.propTypes = {
  title: PropTypes.string
};
export default /*#__PURE__*/memo(FabricDetails);